import Config from '../config'
// ==================================================
// Lee el valor de una cookie
// Params : {str}
// ==================================================   
const readCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// ==================================================
// Borra todas las cookies
// ==================================================   
const deleteAllCookies = function () {
  let configuration = new Config();
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    if (configuration.DiccionarioCookiesAGuardar.indexOf(name.trim()) > -1) {
      if (document.domain === 'localhost') {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      } else {
        console.log("Delete Cookie - Name : " + name);
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + configuration.dominioCookie;
      }
    }
  }
}

// ==================================================
// Borra cookie según nombre dado 
// ================================================== 

const deleteCookieName = function (n) {
  let configuration = new Config();
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

    if (n == name.trim()) {
      if (document.domain === 'localhost') {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      } else {
        //console.log("Delete Cookie - Name : " + name);
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + configuration.dominioCookie;
      }
    }
  }
}

const getCookiesAll = () => {
    const cookiesList = {}
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        var nameEQ = `${name}=`
        var value = cookie.substring(nameEQ.length, cookie.length);
        cookiesList[name.trim()] = value
    }
    
    return cookiesList
}
module.exports = {
  readCookie,
  deleteAllCookies,
    deleteCookieName,
    getCookiesAll
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/cookieHelper.js